module.exports = __webpack_public_path__ + "beauty-model-84d9be.webp";